export const CLOSED_HEADER_BANNERS_COOKIE_NAME = 'closedHeaderBanners';
export const ANIMATION_SPEED = 200;
